<template>
  <div class="py-3 ipmodal-main-overflow">
    <b-overlay :show="showSearchLoader" class="h-100">
      <section class="d-flex h-100">
        <section class="createjobs-teams-left-container">
          <div class="relativeclass w-100 teams-innerInputField">
            <img
              class="teams-setImage"
              src="../../../assets/img/search-bar-icon.svg"
              alt=""
            />

            <b-form-input
              placeholder="Search Feedback Form"
              type="search"
              class="search-input"
              v-model.trim="searchName"
              @update="onSearch"
              debounce="500"
            >
            </b-form-input>
          </div>

          <div
            id="scrollToTop"
            class="overflow-auto"
            style="height: calc(100vh - 395px)"
            @scroll="onScroll"
          >
            <template
              v-if="
                (searchName == '' &&
                  feedbackform &&
                  feedbackform.length !== 0) ||
                (searchName !== '' && feedbackform && feedbackform.length !== 0)
              "
            >
              <div
                @click="getId(feed)"
                :class="
                  feed.feedbackFormID == selectedFeedbackExists
                    ? 'common-selected-card'
                    : ''
                "
                class="
                  common-white-card
                  pointer
                  d-flex
                  align-items-center
                  mt-2
                  mr-1
                "
                v-for="(feed, index) in feedbackform"
                :key="index"
              >
                <b-card>
                  <div class="new-center-radio">
                    <b-form-radio
                      v-model="selectedFeedback"
                      @change="feedbackData"
                      :value="feed"
                    >
                    </b-form-radio>
                  </div>
                  <div class="ipModal-content-font text-truncate">
                    {{ feed.name }}
                  </div>
                </b-card>
              </div>
              <div class="d-flex justify-content-center m-3" v-if="showLoader">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </template>
            <template
              v-else-if="
                searchName !== '' && feedbackform && feedbackform.length == 0
              "
            >
              <div
                class="
                  h-100
                  d-flex
                  flex-column
                  align-items-center
                  justify-content-center
                  w-100
                "
              >
                <div>
                  <img
                    src="../../../assets/new-createjobs/no-matching-results.svg"
                    alt=""
                  />
                </div>
                <div class="mt-2 teams-empty-container-font">
                  No matching results for "{{ searchName }}"
                </div>
              </div>
            </template>
          </div>
        </section>
        <section class="w-70 ml-2 h-100">
          <template
            v-if="
              selectedFeedback && Object.keys(selectedFeedback).length !== 0
            "
          >
            <div class="d-flex align-items-center justify-content-between">
              <div class="ipmodal-right-head text-truncate">
                {{ selectedFeedback.name }}
              </div>
              <template v-if="selectedFeedbackExists"
                ><div
                  v-if="!editSkill && roles.includes('PUT_FEEDBACK_FORM')"
                  @click="editorDiscardorDeleteSkill('edit', '')"
                  class="
                    ipmodal-right-head-two
                    d-flex
                    align-items-center
                    pointer
                    mr-3
                  "
                >
                  <img
                    class="mr-2"
                    src="@/assets/new-createjobs/edit-svg.svg"
                    alt=""
                  />

                  <div class="pointer">Edit</div>
                </div>
              </template>
            </div>
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                w-100
                m-2
              "
            >
              <div v-if="editSkill">
                <div class="d-flex align-items-center">
                  <div class="skill-font">Skill Evaluation</div>
                  <div
                    class="error-txt-tc d-flex align-items-center ml-2"
                    v-if="skillEval"
                  >
                    <img
                      src="../../../assets/img/feedbackform/error-skill-eval.svg"
                      alt=""
                    />

                    <span class="ml-1">Required</span>
                  </div>
                </div>
                <div class="d-flex new-center-radio">
                  <b-form-radio-group
                    @change="skillUpdate()"
                    class="radio-class"
                    :options="options"
                    value-field="value"
                    text-field="name"
                    disabled-field="notEnabled"
                    v-model="markingType"
                  ></b-form-radio-group>
                </div>
              </div>

              <div
                class="ipmodal-right-head-two d-flex align-items-center mr-4"
                v-if="editSkill"
              >
                <div
                  class="mr-3 pointer"
                  @click="editorDiscardorDeleteSkill('discard', '')"
                >
                  Discard Changes
                </div>
                <div class="mr-3">
                  <img src="@/assets/new-createjobs/Line.svg" alt="" />
                </div>
                <div
                  :class="disableSave ? 'ip-opacity' : 'pointer'"
                  @click="!disableSave ? (cloneModal = true) : ''"
                >
                  Save as new
                </div>
              </div>
            </div>
            <div
              class="w-100"
              :style="
                editSkill
                  ? 'height: calc(100vh - 438px);'
                  : 'height: calc(100vh - 389px);'
              "
            >
              <div
                class="overflow-auto"
                id="scrollTobottom"
                :class="
                  editSkill
                    ? 'check-fdbk-height-class'
                    : 'check-noAdd-height-class'
                "
              >
                <draggable :list="skills">
                  <div
                    class="d-flex align-items-center w-100 px-1"
                    v-for="(feed, index) in skills"
                    :key="index"
                    :class="index !== skills.length - 1 ? 'mb-3' : 'mb-0'"
                  >
                    <div style="width: 40px" v-if="editSkill">
                      <img
                        src="@/assets/customfield/dragndrop.svg"
                        alt=""
                        class="pointer"
                      />
                    </div>

                    <div
                      class="common-new-white-card"
                      :style="!editSkill ? 'width:100%' : 'width: 93%'"
                    >
                      <b-card v-if="!editSkill">
                        <div class="d-flex align-items-center w-100">
                          <div class="d-flex w-60">
                            <div class="main-head-ipmodal text-truncate">
                              {{ feed.name
                              }}<span class="asterik" v-if="feed.mandatory"
                                >*&nbsp;</span
                              >
                            </div>
                          </div>
                          <div class="w-40 d-flex justify-content-end">
                            <div
                              class="pff-rating d-flex align-items-center"
                              v-if="feed.markingType == 'rating'"
                            >
                              <div class="rating-font">Rating</div>
                              <b-form-rating
                                variant="primary"
                                disabled
                                class="scorerate newInt-rating"
                              ></b-form-rating>
                            </div>
                            <div
                              class="topDiv d-flex align-items-center"
                              v-if="feed.markingType == 'score'"
                            >
                              <div>
                                <label class="newInt-inner-containers-subhead"
                                  >Score</label
                                >
                              </div>
                              <div class="ml-2">
                                <b-form-input
                                  class="
                                    newInt-previewInputField-score
                                    no-spinner
                                  "
                                  disabled
                                  type="number"
                                >
                                </b-form-input>
                              </div>
                              <div
                                class="ml-2 newInt-preview-container-subFont"
                              >
                                Out of 10
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="" v-if="feed.commentMode === true">
                          <b-form-textarea
                            :class="
                              feed.markingType == 'score' ? 'mt-2' : 'mt-1'
                            "
                            class="newInt-previewInputField"
                            rows="2"
                            type="text"
                            placeholder="Comments"
                            max-rows="5"
                            disabled
                          >
                          </b-form-textarea>
                        </div>
                      </b-card>
                      <b-card v-else>
                        <div
                          class="
                            d-flex
                            align-items-center
                            justify-content-between
                            w-100
                          "
                        >
                          <div
                            class="
                              d-flex
                              align-items-center
                              w-100
                              justify-content-between
                            "
                          >
                            <div class="d-flex align-items-center">
                              <b-form-input
                                v-model.trim="feed.name"
                                :class="
                                  $v.skills.$each[index].$error ||
                                  duplicateSkillName[index]
                                    ? 'oneline-error'
                                    : 'oneline-inputField'
                                "
                                @input="triggerValidation(index)"
                              >
                              </b-form-input>
                              <div
                                v-if="
                                  $v.skills.$each[index].name.$dirty &&
                                  !$v.skills.$each[index].name.required
                                "
                              >
                                <img
                                  v-b-tooltip.hover.top="'Required'"
                                  class="newIcons-hover ml-3"
                                  src="@/assets/new-createjobs/new-validation-icon.svg"
                                  alt="Validation icon"
                                />
                              </div>
                              <div
                                v-else-if="
                                  !$v.skills.$each[index].name.maxLength &&
                                  $v.skills.$each[index].name.required
                                "
                              >
                                <img
                                  v-b-tooltip.hover.top="
                                    'Should not exceed 128 characters'
                                  "
                                  class="newIcons-hover ml-3"
                                  src="@/assets/new-createjobs/new-validation-icon.svg"
                                  alt="Validation icon"
                                />
                              </div>
                              <div v-else-if="duplicateSkillName[index]">
                                <img
                                  v-b-tooltip.hover.top="' Name already exists'"
                                  class="newIcons-hover ml-3"
                                  src="@/assets/new-createjobs/new-validation-icon.svg"
                                  alt="Validation icon"
                                />
                              </div>
                            </div>
                            <div
                              class="
                                w-40
                                d-flex
                                justify-content-end
                                align-items-center
                              "
                            >
                              <div
                                class="
                                  pff-rating
                                  d-flex
                                  align-items-center
                                  mr-3
                                "
                                v-if="feed.markingType == 'rating'"
                              >
                                <div class="rating-font">Rating</div>
                                <b-form-rating
                                  disabled
                                  variant="primary"
                                  class="scorerate newInt-rating"
                                ></b-form-rating>
                              </div>
                              <div
                                class="topDiv d-flex align-items-center mr-3"
                                v-else-if="feed.markingType == 'score'"
                              >
                                <div>
                                  <label class="newInt-inner-containers-subhead"
                                    >Score</label
                                  >
                                </div>
                                <div class="ml-2">
                                  <b-form-input
                                    class="
                                      newInt-previewInputField-score
                                      no-spinner
                                    "
                                    disabled
                                    type="number"
                                  >
                                  </b-form-input>
                                </div>
                                <div
                                  class="ml-2 newInt-preview-container-subFont"
                                >
                                  Out of 10
                                </div>
                              </div>
                              <div
                                @click="
                                  skills.length > 1
                                    ? editorDiscardorDeleteSkill(
                                        'delete',
                                        index
                                      )
                                    : ''
                                "
                              >
                                <img
                                  :class="
                                    skills.length > 1 ? 'pointer' : 'ip-opacity'
                                  "
                                  class="newIcons-hover"
                                  src="@/assets/new-createjobs/delete-icon.svg"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex align-items-center mt-2">
                          <div class="d-flex align-items-center">
                            <div class="common-single-checkbox">
                              <b-form-checkbox
                                v-model="feed.commentMode"
                              ></b-form-checkbox>
                            </div>
                            <div class="comm-font">Comments</div>
                          </div>

                          <div class="d-flex align-items-center ml-5">
                            <div class="common-single-checkbox">
                              <b-form-checkbox
                                v-model="feed.mandatory"
                              ></b-form-checkbox>
                            </div>
                            <div class="comm-font">Mandatory</div>
                          </div>
                        </div>
                        <b-form-textarea
                          class="newInt-previewInputField mt-3"
                          v-if="feed.commentMode === true"
                          rows="2"
                          type="text"
                          placeholder="Comments "
                          max-rows="5"
                          disabled
                        ></b-form-textarea>
                      </b-card>
                    </div>
                  </div>
                </draggable>
              </div>
              <div class="d-flex align-items-center w-100" v-if="editSkill">
                <div style="width: 40px"></div>
                <div
                  class="common-blue-card"
                  :class="
                    disableNewSkill ? 'common-blue-card-disabled' : 'pointer'
                  "
                  style="width: 93%"
                  @click="!disableNewSkill ? addnewSkill() : ''"
                >
                  <b-card>
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-between
                        w-100
                      "
                    >
                      <div
                        class="d-flex align-items-center"
                        :class="disableNewSkill ? 'defaultCursor' : 'pointer'"
                      >
                        <img
                          class="mr-2"
                          src="../../../assets/new-createjobs/blue-plus-icon.svg"
                          alt=""
                        />
                        <span class="ipmodal-addround-font">
                          Add New Skill
                        </span>
                      </div>
                    </div>
                  </b-card>
                </div>
              </div>
            </div>
          </template>

          <template v-else>
            <div
              class="
                h-100
                d-flex
                flex-column
                align-items-center
                justify-content-center
                w-100
              "
            >
              <div>
                <img
                  src="../../../assets/new-createjobs/no-data-icon.svg"
                  alt=""
                />
              </div>
              <div class="mt-2 not-selectround-font">
                Please select any feedback form on the left side to view its
                content
              </div>
            </div>
          </template>
        </section>
      </section>
    </b-overlay>
    <CloneModal
      @handle-resetClone="resetClone"
      :cloneModal="cloneModal"
      :duplicatecloneName="duplicateCloneName"
      header="Save Feedback Form"
      subHeader="Feedback Form Name"
      placeholder="Enter"
      errorMessage="Feedback Form Name exists"
      @closeCloneModal="closeCloneModal"
      @change-duplicate-name="duplicateCloneName = false"
      @handle-clone="saveNew"
      buttonName="Save"
      :buttonLoader="buttonLoader"
    />
  </div>
</template>

<script>
import {
  getFeedbackFormSort,
  updatefeedbackform,
  addfeedbackform,
} from "../../../utils/apiFunctions.js";
import draggable from "vuedraggable";
import { required, maxLength, helpers } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";

import CloneModal from "../../../views/InterviewProcess/cloneModal.vue";

export default {
  name: "FeedbackFormModal",
  components: {
    CloneModal,
    draggable,
  },
  props: {
    feedbackFormID: String,
  },
  data() {
    return {
      showSkillSpinner: false,
      editSkillIndex: null,
      buttonLoader: false,
      duplicateSkillName: [],
      showSearchLoader: false,
      markingType: "",
      skillrating: {
        name: "",
        markingType: "",
        mark: "",
        comments: "",
        commentMode: true,
        mandatory: false,
      },
      skills: [],
      options: [
        {
          value: "rating",
          name: "Rating",
        },
        {
          value: "score",
          name: "Score",
        },
      ],
      editSkill: false,
      duplicateCloneName: false,
      searchName: "",
      cloneModal: false,
      sortColumn: "updatedAt",
      sortOrder: "-1",
      page: 0,
      count: 15,
      total: null,
      pageEnd: 0,
      showLoader: false,
      LoaderStatus: true,
      feedbackform: [],
      selectedFeedback: {},
      previousSkills: [],
      feedName: "",
      processID: "",
    };
  },
  validations() {
    return {
      skills: {
        $each: {
          name: {
            required,
            maxLength: maxLength(128),
            alpha: helpers.regex("alpha", /^[A-Za-z0-9].*$/),
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters(["roles"]),
    skillEval() {
      return this.markingType == null;
    },
    disableSave() {
      return (
        this.duplicateSkillName?.includes(true) ||
        this.$v.$invalid ||
        this.markingType == null
      );
    },
    disableNewSkill() {
      return this.skills.some((val) => val.name == "");
    },
    selectedFeedbackExists() {
      return (
        this.selectedFeedback &&
        this.selectedFeedback.feedbackFormID != undefined
      );
    },
  },
  async created() {
    if (this.feedbackFormID) {
      this.processID = this.feedbackFormID;
    }
    await this.getallfeedbackforms();
    this.feedbackData();
  },
  watch: {
    disableSave(newValue) {
      this.$emit("update-disable-save", newValue);
    },
    selectedFeedback(newVal) {
      if (newVal && newVal.skills) {
        this.skills = [...newVal.skills];
        this.previousSkills = JSON.parse(JSON.stringify(this.skills));
      }
    },
    skills: {
      handler(newSkills) {
        if (Array.isArray(newSkills)) {
          this.duplicateSkillName = newSkills.map((skill, index) => {
            if (skill && skill.name) {
              const currentName = skill.name.toLowerCase();
              return newSkills.some(
                (s, i) =>
                  i !== index &&
                  s &&
                  s.name &&
                  s.name.toLowerCase() === currentName
              );
            }
            return false;
          });
        } else {
          this.duplicateSkillName = [];
        }
      },
      deep: true,
    },
  },

  methods: {
    scrollFunctionality() {
      let element = document.getElementById("scrollToTop");
      if (element) {
        element.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },

    getId(feed) {
      this.selectedFeedback = feed;
      this.feedbackData();
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const scrollContainer = document.getElementById("scrollTobottom");

        scrollContainer.scrollBy({
          top: 5000,
          behavior: "smooth",
        });
      });
    },
    triggerValidation(index) {
      this.$v.skills.$each[index].$touch();
    },
    addnewSkill() {
      this.skillrating.markingType = this.markingType;
      this.skills.push({ ...this.skillrating });
      this.scrollToBottom();
    },

    skillUpdate() {
      this.skills.forEach((skill) => {
        skill.markingType = this.markingType;
      });
    },

    onSearch() {
      this.selectedFeedback = {};
      this.page = 0;
      this.getallfeedbackforms();
      this.showSearchLoader = true;
    },
    saveNew(cloningName) {
      this.feedName = cloningName;
      this.buttonLoader = true;
      this.savefeedback();
    },
    editorDiscardorDeleteSkill(val, index) {
      if (val === "edit") {
        this.editSkill = true;
        this.previousSkills = JSON.parse(JSON.stringify(this.skills));
      } else if (val === "discard") {
        this.editSkill = false;
        this.skills = JSON.parse(JSON.stringify(this.previousSkills));
        this.markingType = this.previousMarkingType;
      } else if (val === "delete") {
        this.skills.splice(index, 1);
      }
    },

    closeCloneModal() {
      this.cloneModal = false;
    },
    resetClone() {
      this.duplicateCloneName = false;
    },
    resetMethod() {
      this.searchName = "";
      this.editSkill = false;
      this.$v.$reset();
      this.showSearchLoader = true;
      this.page = 0;
      this.$nextTick(() => {
        this.scrollFunctionality();
      });
      this.editorDiscardorDeleteSkill("discard");
      this.getallfeedbackforms();
    },
    async savefeedback() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.skills = this.skills.map((skill, index) => {
          skill.id = index + 1;
          return skill;
        });
        try {
          this.LoaderStatus = true;
          let data = {
            feedbackFormID: this.selectedFeedback.feedbackFormID,
            name: this.cloneModal ? this.feedName : this.selectedFeedback?.name,
            skills: this.skills,
            screenshot: this.selectedFeedback.screenshot,
            recommendation: this.selectedFeedback.selectedrecommendations,
          };
          let response = {};
          if (this.cloneModal) {
            response = await addfeedbackform(data);
          } else {
            response = await updatefeedbackform(data);
          }
          if (response.status === 200) {
            if (response.data.data?.feedbackFormID) {
              this.processID = response.data.data.feedbackFormID;
              this.closeCloneModal();
            }
            await this.getallfeedbackforms();
            this.buttonLoader = false;
            this.editSkill = false;
          } else if (response.status == 409) {
            this.duplicateCloneName = true;
            this.buttonLoader = false;
          }
        } catch (error) {
          this.buttonLoader = false;
          console.error(`Failed! Adding: ${error.message}`);
        }
      } else {
        console.warn("Form contains errors or duplicates.");
      }
    },
    onScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.pageEnd, 0, this.total) &&
          !this.showLoader &&
          this.feedbackform.length
        ) {
          this.showLoader = true;
          this.page++;
          this.getallfeedbackforms();
        }
      }
    },
    checkbetween(x, min, max) {
      // Return `true` if `x` is between `min` and `max`, otherwise `false`.
      return x > min && x < max;
    },
    feedbackData() {
      this.skills = [];
      this.processID = this.selectedFeedback.feedbackFormID;
      if (this.selectedFeedback && this.selectedFeedback.skills) {
        for (let n in this.selectedFeedback.skills) {
          const skill = this.selectedFeedback.skills[n];

          this.skills.push({
            name: skill.name,
            markingType: skill.markingType,
            mark: "",
            comments: "",
            commentMode: skill.commentMode,
            mandatory: skill.mandatory,
          });
        }
      }

      this.editSkill = false;

      const markingTypes = this.skills?.map((skill) => skill.markingType);
      const allSame = markingTypes?.every((val) => val === markingTypes[0]);
      this.markingType = allSame ? markingTypes[0] : null;
      this.previousMarkingType = this.markingType;
      this.previousSkills = JSON.parse(JSON.stringify(this.skills));
    },
    async getallfeedbackforms() {
      let payload = {
        searchQuery: this.searchName,
        order: this.sortOrder,
        sortBy: this.sortColumn,
        type: "1",
        page: this.page,
        count: this.count,
      };
      if (this.feedbackFormID) {
        payload.feedbackFormID = this.feedbackFormID;
        payload.selected = true;
      }
      try {
        const response = await getFeedbackFormSort(payload);

        if (response.status === 200) {
          this.showSearchLoader = false;
          if (this.page === 0) {
            this.feedbackform = response.data.data.data;
          } else {
            this.feedbackform = [
              ...this.feedbackform,
              ...response.data.data.data,
            ];
          }
          this.total = response.data.data.total;
          this.pageEnd = response.data.data.pageEnd;
          this.showLoader = false;
          // this.showLoader =
          //   response.data.data.total !== response.data.data.pageEnd;
          this.LoaderStatus = false;
          if (this.processID) {
            this.selectedFeedback = this.feedbackform.find(
              (item) => item.feedbackFormID === this.processID
            );
          }
        } else if (response.status === 500) {
          this.showSearchLoader = false;
        } else {
          this.showSearchLoader = false;
        }
      } catch (error) {
        console.error("Error fetching feedback forms:", error);
        this.LoaderStatus = false;
        this.showSearchLoader = false;
      }
    },
  },
};
</script>

<style scoped>
.common-new-white-card .card {
  border-radius: 10px;
  width: 100%;
  box-shadow: 0px 4px 8px 0px #0000002b;
}

.common-new-white-card .card-body {
  padding: 10px 15px;
  flex-direction: column;
  align-items: flex-start;
}

.comm-font {
  font-family: var(--montserrat);
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #344054;
}

.rating-font {
  font-family: var(--lato);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
  color: #444444;
}

.manage-radio-main.custom-control {
  display: flex;
  align-items: center;
}

.skill-font {
  font-family: var(--montserrat);
  font-size: 14px;
  font-weight: 500;
  color: #344054;
  line-height: 24px;
}
.ip-opacity {
  opacity: 0.5;
}
</style>
